import m from "mithril";
import i18n from "../../shared/i18n/i18n";
import UnitSettingsUtilities from "./unit_settings_utilities";
import ModalManager from "../../shared/modal";
import Modal_Confirm from "../../shared/components/modal_confirm";

function changeUnitActiveStatus(unit, saving) {
    UnitSettingsUtilities.toggleActiveStatus([unit.id], !unit.isActive, saving);
    unit.isActive = !unit.isActive;
}

function confirmReenrolmentPrompt(unit, saving) {
    let inActivateUnit = () => changeUnitActiveStatus(unit, saving);

    const attributes = {
        confirmCallback: inActivateUnit,
        cancelCallback: null,
        messageText: unit.isActive ? [m("i.icon-info.mr-1"), i18n.t("inactivate_unit_message")] : [m("i.icon-info.mr-1"), i18n.t("activate_unit_message")],
        confirmButtonLabel: unit.isActive ? i18n.t("inactivate_unit_button_text") : i18n.t("activate_unit_button_text"),
        cancelButtonLabel: i18n.t("close"),
        cancelButtonClasses: !unit.isActive ? "button.btn-error" : "button",
        confirmButtonClasses: unit.isActive ? "button.btn-error" : "button.btn-yes",
    };

    ModalManager.open(unit.isActive ? i18n.t("inactivate_unit_button_text") : i18n.t("activate_unit_button_text"),
        [], Modal_Confirm, attributes)
}

export function getUnitActiveStatusSlider(unit, saving) {
    return [m(".flex-row justify-between", [
        m("h3.mb-0", i18n.t("active")),
        m(".btn btn-toggle", {
            onclick: function () {
                confirmReenrolmentPrompt(unit, saving);
            },
            class: unit.isActive ? "active" : ""
        })
    ]),

        m("div.form-label.mt-2", [m("i.icon-info.m-1"), i18n.t("active_slider_warning_message")])];
}
